
export interface ISignIn {

    password: string;
    // email: string;
    username: string;
}

export interface ISignInPayload {
    password: string;
    // email: string;
    username: string;
}

export const EmptyISignInPayload: ISignIn = {
    password: '',
    // email: '',
    username:'',
}